import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Link as RouterLink } from 'react-router';
import * as React from 'react';

const LinkBehavior = React.forwardRef((props, ref) => {
    const { href, ...other } = props;
    // Map href (MUI) -> to (react-router)
    return <RouterLink data-testid="custom-link" ref={ref} to={href} {...other} />;
});


export function Theme(props) {
    const theme = createTheme({
        cssVariables: true,
        components:{
            MuiAppBar:{
                styleOverrides:{
                    root:{
                        backgroundColor: '#FFF3E0',
                        color: '#8D6E63',
                    }
                }
            },
            MuiLink:{
                defaultProps: {
                    component: LinkBehavior,
                },

            },
            MuiTableCell: {
                styleOverrides: {
                    head: {
                        fontWeight: 'bold',
                    },
                },
            },
            MuiListItemIcon:{
                styleOverrides:{
                    root:{
                        minWidth: '36px',
                    }
                }
            },
            MuiListItemText:{
                styleOverrides:{
                    primary:{
                        fontSize: '14px'
                    }
                }
            }

        },
        colorSchemes:{
            light: {
                palette: {
                    primary: {
                        main: '#44b48a',
                        contrastText: '#FFFFFF',
                    },

                    info: {
                        main: '#8D6E63',
                    },
                    text: {
                        primary: 'rgb(66,66,66)',
                        secondary: 'rgb(141, 110, 99)',
                    },

                },

            }
        }

    });

    return (
        <ThemeProvider theme={theme}>
            {props.children}
        </ThemeProvider>
    );
}
